import DatePicker from 'vue2-datepicker';
import utils from './utils.js';
import { Validator } from 'simple-vue-validator';

export default {
    components: {
        DatePicker
    },
    props: ['selected_staff', 'staff_members', 'login_user_id', 'salon_selected', 'selected_staff_start_time', 'selected_staff_end_time'],
    name: 'break_popover',
    data(){
        return {
            work_hrs_date:'',
            start_time : '',
            end_time :'',
            staff_selected: 0,
            start_time_greater_than_end_time: false,
        }
    },
    mounted(){
        this.work_hrs_date  = utils.date_from_sql_to_bookjoy_format(this.$store.state.selected_date);
        this.start_time     = utils.time_from_sql_to_bookjoy_format(this.selected_staff_start_time);
        this.end_time       = utils.time_from_sql_to_bookjoy_format(this.selected_staff_end_time);
        this.staff_selected = this.selected_staff;
        this.start_time_greater_than_end_time = false;
    },
    methods:{
        save_staff_hrs() {
            let _this = this;
            this.$validate().then(function (success) {
                if (success) {
                    var start_time = utils.time_from_bookjoy_format_to_sql(_this.start_time)
                    var end_time = utils.time_from_bookjoy_format_to_sql(_this.end_time)
                    if(!utils.comparing_startime_and_endtime(start_time, end_time))
                    {
                        _this.start_time_greater_than_end_time = true;
                        return;
                    }
                    document.getElementsByClassName('save_staff_hrs_button')[0].innerHTML="Please Wait";
                    document.getElementsByClassName('save_staff_hrs_button')[0].disabled=true;
                    _this.start_time_greater_than_end_time = false;
                    _this.$store.dispatch('edit_staff_hrs',[_this.$store.state.api,
                        _this.salon_selected.store_id,
                        _this.staff_selected,
                        utils.date_from_bookjoy_format_to_sql(_this.work_hrs_date),
                        start_time,
                        end_time,
                        _this.login_user_id,
                        '', 
                        _this.Constants.WORKING_STATUS_INDICATOR_EDIT_STAFF_HOURS
                    ]).then(()=>{
                        _this.$emit('update_events', 'staff_work_popup');
                    })
                }
            });
        }
    },
    validators: {
        start_time: function (value) {
          return Validator.value(value).required();
        },
        end_time: function (value) {
            return Validator.value(value).required();
        },
        staff_selected: function (value) {
            return Validator.value(value).required();
        }
    }
}